<main class="doctor-application-page" [dir]="isAr ? 'rtl' : 'ltr'">
  <section class="doctor-application-card">
    <div class="page-heading">
      <span>{{ 'atw.doctorApply.badge' | transloco }}</span>
      <h1>{{ 'atw.doctorApply.title' | transloco }}</h1>
      <p>{{ 'atw.doctorApply.subtitle' | transloco }}</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <div class="application-stepper">
        <ng-container *ngFor="let step of steps; let index = index; let last = last">
          <button
            type="button"
            class="step-pill"
            [class.active]="currentStep === index"
            [class.done]="currentStep > index"
            (click)="index <= currentStep && (currentStep = index)"
          >
            <span>{{ step }}</span>{{ getStepLabel(index) }}
          </button>

          <i class="step-line" *ngIf="!last"></i>
        </ng-container>
      </div>

      <!-- ========================= -->
      <!-- Step 1: Doctor Data -->
      <!-- ========================= -->
      <ng-container *ngIf="currentStep === 0">
        <div class="form-grid">
          <label>
            <span>{{ isAr ? 'الاسم بالكامل' : ('atw.doctorApply.fullName' | transloco) }} *</span>
            <input
              type="text"
              formControlName="name"
              [placeholder]="'atw.doctorApply.fullNamePlaceholder' | transloco"
            />
            <small *ngIf="isInvalid('name')">
              {{ 'atw.doctorApply.nameRequired' | transloco }}
            </small>
          </label>

          <label>
            <span>{{ isAr ? 'رقم الموبايل' : ('atw.doctorApply.mobile' | transloco) }} *</span>
            <input
              type="tel"
              formControlName="mobile"
              [placeholder]="'atw.doctorApply.mobilePlaceholder' | transloco"
            />
            <small *ngIf="isInvalid('mobile')">
              {{ 'atw.doctorApply.phoneRequiredForCv' | transloco }}
            </small>
          </label>

          <label>
            <span>{{ isAr ? 'البريد الإلكتروني' : ('atw.doctorApply.email' | transloco) }}</span>
            <input
              type="email"
              formControlName="email"
              [placeholder]="'atw.doctorApply.emailPlaceholder' | transloco"
            />
            <small *ngIf="isInvalid('email')">
              {{ 'atw.doctorApply.emailInvalid' | transloco }}
            </small>
          </label>

          <label>
            <span>{{ isAr ? 'التخصص' : ('atw.doctorApply.specialty' | transloco) }}</span>
            <input
              type="text"
              formControlName="specialty"
              [placeholder]="'atw.doctorApply.specialtyPlaceholder' | transloco"
            />
          </label>

          <label>
            <span>{{ isAr ? 'مكان الإقامة' : ('atw.doctorApply.residencePlace' | transloco) }}</span>
            <input type="text" formControlName="residence_place" />
          </label>

          <label>
            <span>{{ isAr ? 'مكان الميلاد' : ('atw.doctorApply.birthPlace' | transloco) }}</span>
            <input type="text" formControlName="birth_place" />
          </label>

          <label>
            <span>{{ isAr ? 'تاريخ الميلاد' : ('atw.doctorApply.birthDate' | transloco) }}</span>
            <input
              type="date"
              formControlName="birth_date"
            />
          </label>
        </div>

        <div class="check-grid degree-check-grid">
          <label>
            <input type="checkbox" formControlName="has_phd" />
            {{ isAr ? 'حاصل على دكتوراه' : ('atw.doctorApply.hasPhd' | transloco) }}
          </label>

          <label>
            <input type="checkbox" formControlName="has_master" />
            {{ isAr ? 'حاصل على ماجستير' : ('atw.doctorApply.hasMaster' | transloco) }}
          </label>
        </div>

        <div class="degree-fields" *ngIf="form.get('has_phd')?.value">
          <h3>{{ isAr ? 'بيانات الدكتوراه' : 'PhD details' }}</h3>

          <div class="form-grid">
            <label>
              <span>{{ isAr ? 'مصدر الدكتوراه' : ('atw.doctorApply.phdSource' | transloco) }} *</span>
              <input type="text" formControlName="phd_source" />
              <small *ngIf="isInvalid('phd_source')">
                {{ isAr ? 'مصدر الدكتوراه مطلوب.' : 'PhD source is required.' }}
              </small>
            </label>

            <label>
              <span>{{ isAr ? 'سنة الدكتوراه' : 'PhD year' }} *</span>
              <input
                type="number"
                formControlName="phd_year"
                min="1940"
                max="2100"
                [placeholder]="isAr ? 'مثال: 2024' : 'Example: 2024'"
              />
              <small *ngIf="isInvalid('phd_year')">
                {{ isAr ? 'أدخل سنة دكتوراه صحيحة بين 1940 و2100.' : 'Enter a valid PhD year between 1940 and 2100.' }}
              </small>
            </label>
          </div>
        </div>

        <div class="degree-fields" *ngIf="form.get('has_master')?.value">
          <h3>{{ isAr ? 'بيانات الماجستير' : 'Master details' }}</h3>

          <div class="form-grid">
            <label>
              <span>{{ isAr ? 'مصدر الماجستير' : ('atw.doctorApply.masterSource' | transloco) }} *</span>
              <input type="text" formControlName="master_source" />
              <small *ngIf="isInvalid('master_source')">
                {{ isAr ? 'مصدر الماجستير مطلوب.' : 'Master source is required.' }}
              </small>
            </label>

            <label>
              <span>{{ isAr ? 'سنة الماجستير' : 'Master year' }} *</span>
              <input
                type="number"
                formControlName="master_year"
                min="1940"
                max="2100"
                [placeholder]="isAr ? 'مثال: 2020' : 'Example: 2020'"
              />
              <small *ngIf="isInvalid('master_year')">
                {{ isAr ? 'أدخل سنة ماجستير صحيحة بين 1940 و2100.' : 'Enter a valid master year between 1940 and 2100.' }}
              </small>
            </label>
          </div>
        </div>

        <div class="form-grid extra-data-grid">
          <label>
            <span>{{ 'atw.doctorApply.university' | transloco }}</span>
            <input
              type="text"
              formControlName="university"
              [placeholder]="'atw.doctorApply.universityPlaceholder' | transloco"
            />
          </label>

          <label>
            <span>{{ 'atw.doctorApply.graduationYear' | transloco }}</span>
            <input
              type="number"
              formControlName="graduation_year"
              min="1940"
              max="2100"
            />
            <small *ngIf="isInvalid('graduation_year')">
              {{ isAr ? 'أدخل سنة تخرج بين 1940 و2100.' : 'Enter a graduation year between 1940 and 2100.' }}
            </small>
          </label>

          <label>
            <span>{{ 'atw.doctorApply.fellowship' | transloco }}</span>
            <input type="text" formControlName="fellowship" />
          </label>

          <label>
            <span>{{ 'atw.doctorApply.classificationStatus' | transloco }}</span>
            <input type="text" formControlName="classification_status" />
          </label>
        </div>

        <div class="check-grid">
          <label>
            <input type="checkbox" formControlName="ksa_experience" />
            {{ 'atw.doctorApply.ksaExperience' | transloco }}
          </label>

          <label>
            <input type="checkbox" formControlName="transfer_of_sponsorship" />
            {{ 'atw.doctorApply.transferSponsorship' | transloco }}
          </label>

          <label>
            <input type="checkbox" formControlName="visa" />
            {{ 'atw.doctorApply.visaAvailable' | transloco }}
          </label>

          <label>
            <input type="checkbox" formControlName="has_dataflow" />
            {{ 'atw.doctorApply.dataflow' | transloco }}
          </label>
        </div>

        <label class="full-width">
          <span>{{ 'atw.doctorApply.notes' | transloco }}</span>
          <textarea
            formControlName="notes"
            rows="4"
            [placeholder]="'atw.doctorApply.notesPlaceholder' | transloco"
          ></textarea>
        </label>
      </ng-container>

      <!-- ========================= -->
      <!-- Step 2: Doctor Image -->
      <!-- ========================= -->
      <section class="cv-option upload-image-step" *ngIf="currentStep === 1">
        <div class="upload-icon">
          <img src="assets/as/16.webp" alt="" />
        </div>

        <strong>{{ 'atw.doctorApply.imageRequired' | transloco }}</strong>
        <p>{{ 'atw.doctorApply.imageText' | transloco }}</p>

        <input
          #imageInput
          type="file"
          accept="image/*"
          hidden
          (change)="onImageChange($event)"
        />

        <button
          type="button"
          class="upload-button"
          (click)="imageInput.click()"
        >
          {{ selectedImage ? selectedImage.name : ('atw.doctorApply.chooseImage' | transloco) }}
          <span>⬆</span>
        </button>
      </section>

      <!-- ========================= -->
      <!-- Step 3: CV + Certificates -->
      <!-- ========================= -->
      <section class="cv-option" *ngIf="currentStep === 2">
        <div>
          <strong>{{ 'atw.doctorApply.cvOptionTitle' | transloco }}</strong>
          <p>{{ 'atw.doctorApply.cvOptionText' | transloco }}</p>
        </div>

        <input
          #cvInput
          type="file"
          accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          hidden
          (change)="onCvChange($event)"
        />

        <button
          type="button"
          class="secondary-action"
          (click)="cvInput.click()"
        >
          {{ selectedCv ? selectedCv.name : ('atw.doctorApply.chooseCv' | transloco) }}
        </button>

        <button
          *ngIf="selectedCv"
          type="button"
          class="text-button"
          (click)="removeCv()"
        >
          {{ 'atw.doctorApply.removeCv' | transloco }}
        </button>
      </section>

      <section class="cv-option" *ngIf="currentStep === 2">
        <div>
          <strong>{{ isAr ? 'رفع الشهادات والملفات' : 'Upload certificates and files' }}</strong>
          <p>
            {{
              isAr
                ? 'يمكنك رفع صور أو ملفات PDF للشهادات بحد أقصى 20 ملف.'
                : 'You can upload images or PDF files for certificates, maximum 20 files.'
            }}
          </p>
        </div>

        <input
          #certificatesInput
          type="file"
          accept=".jpg,.jpeg,.png,.webp,.pdf,image/*,application/pdf"
          multiple
          hidden
          (change)="onCertificatesChange($event)"
        />

        <button
          type="button"
          class="secondary-action"
          (click)="certificatesInput.click()"
        >
          {{
            selectedCertificates.length
              ? (isAr ? 'إضافة ملفات أخرى' : 'Add more files')
              : (isAr ? 'اختيار الشهادات' : 'Choose certificates')
          }}
        </button>

        <button
          *ngIf="selectedCertificates.length"
          type="button"
          class="text-button"
          (click)="clearCertificates()"
        >
          {{ isAr ? 'حذف كل الشهادات' : 'Remove all certificates' }}
        </button>

        <small *ngIf="certificateErrorMessage" class="form-message error">
          {{ certificateErrorMessage }}
        </small>

        <div class="selected-files" *ngIf="selectedCertificates.length">
          <p>
            {{
              isAr
                ? 'الملفات المختارة: ' + selectedCertificates.length + ' / 20'
                : 'Selected files: ' + selectedCertificates.length + ' / 20'
            }}
          </p>

          <div
            class="selected-file-row"
            *ngFor="let file of selectedCertificates; let i = index; trackBy: trackByFile"
          >
            <span>{{ file.name }}</span>

            <button
              type="button"
              class="text-button"
              (click)="removeCertificate(i)"
            >
              {{ isAr ? 'حذف' : 'Remove' }}
            </button>
          </div>
        </div>
      </section>

      <p class="form-message error" *ngIf="errorMessage">{{ errorMessage }}</p>
      <p class="form-message success" *ngIf="successMessage">{{ successMessage }}</p>

      <div class="actions">
        <button
          type="button"
          class="secondary-action"
          (click)="currentStep ? previousStep() : goBack()"
        >
          {{ isAr ? 'رجوع' : 'Back' }}
        </button>

        <button
          *ngIf="currentStep < 2"
          type="button"
          class="primary-action"
          (click)="nextStep()"
        >
          {{ 'atw.doctorApply.next' | transloco }}
        </button>

        <button
          *ngIf="currentStep === 2"
          type="submit"
          class="primary-action"
          [disabled]="isSubmitting"
        >
          {{
            isSubmitting
              ? ('atw.doctorApply.submitting' | transloco)
              : ('atw.doctorApply.publicApply' | transloco)
          }}
        </button>
      </div>
    </form>
  </section>
</main>